import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
  Typography,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "src/components/ui/svgIcon/CloseIcon";
import { useFormik } from "formik";
import { BaseBTN } from "src/components/ui";
import * as Yup from "yup";
import { useTheme } from "@emotion/react";
import GuideUsingSmartServicePortalDialog from "./GuideUsingSmartServicePortalDialog";
import SelectRealLegalDialog from "./SelectRealLegalDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Define the validation schema
const validationSchema = Yup.object().shape({
  termsAndConditions: Yup.bool()
    .oneOf([true], "جهت ادامه پذیرفتن قوانین و مقررات الزامی میباشد.")
    .required("جهت ادامه پذیرفتن قوانین و مقررات الزامی میباشد."),
});

// Initial form values
const initialValues = {
  termsAndConditions: false,
};

const ConfirmationDialog = ({ openRegister, onCloseRegister }) => {
  const [open, setOpen] = useState(false);

  const handleOpenRegister = () => {
    setOpen(true);
  };

  const handleCloseRegister = () => {
    setOpen(false);
  };

  const theme = useTheme();
  // Formik hook for form handling and validation
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {},
  });
  const [openRealLegal, setOpenRealLegal] = useState(false);

  const handleOpenRealLegal = () => {
    setOpenRealLegal(true);
  };

  const handleCloseRealLegal = () => {
    setOpenRealLegal(false);
  };
  return (
    <Dialog
      sx={{
        textAlign: "center",
        margin: "0 auto",
        "& div.MuiPaper-root": {
          maxWidth: "80%",
        },
      }}
      open={openRegister[0]}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCloseRegister}
    >
      <DialogTitle textAlign="center" variant="h6" color="primary">
        ثبت‌‌نام در سامانه زنجیره ارزش آبزیان{" "}
        {onCloseRegister ? (
          <IconButton
            aria-label="close"
            onClick={onCloseRegister}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon color={theme.palette.grey.gm} />
          </IconButton>
        ) : null}
      </DialogTitle>
      {openRegister[1] === "MANUAL" ? (
        <Stack>
          <Stack textAlign="right">
            <Typography variant="subtitle2" color="text.primary" textAlign="left" pt={2} px={4}>
              سامانه زنجیره ارزش آبزیان با هدف افزایش بهره‌وری، توسعه و هوشمندسازی زنجیره ارزش آبزیان طراحی و راه‌اندازی
              گردیده‌است، لذا به همین منظور کلیه کاربران استفاده‌کننده از این سامانه جهت احترام و حفظ کلیه حقوق مادی و
              معنوی دست‌اندرکاران سامانه و سایر کاربران استفاده‌کننده و با هدف ارائه بهتر خدمات متعهد به اجرا تمامی مواد
              مندرج در این تعهدنامه گردیدند.
            </Typography>
          </Stack>
          <Stack pt={2}> </Stack>
          <DialogContent>
            <Stack spacing={2} p={2} bgcolor="grey.gs" sx={{ borderRadius: 2 }} mt={2}>
              <Typography variant="subtitle1" color="primary.main" textAlign="left">
                قوانین و مقررات
              </Typography>
              <Typography textAlign="justify">
                استفاده‌کننده از این سامانه به موجب این تعهدنامه متعهد گردید در حفظ کلیه اطلاعات و اسناد خود و سایر
                استفاده‌کنندگان سامانه کوشا باشد و از هرگونه افشای غیرمجاز و کنترل‌نشده اطلاعات این سامانه و همچنین
                اطلاعات سایر کاربران استفاده‌کننده این سامانه در حین و پس از استفاده از این سامانه ممانعت نماید و همچنین
                کلیه اطلاعات، اسناد و مدارکی که به هر نحو فی مابین طرفین مخابره می‌شود باید در دایره محرمانگی اطلاعات
                قرارگیرد و طرف مقابل متعهد و موظف به حفظ آن می‌باشد که این اطلاعات شامل و نه محدود به (کلیه مدارک
                واحدهای فروش، کلیه مدارک تولیدکنندگان و تامین‌کنندگان ، قیمت‌های خرید و فروش فی مابین طرفین)ست.
              </Typography>
              <Typography textAlign="justify">
                1- کاربر استفاده‌کننده از این سامانه متعهد گردید کلیه اطلاعات خود در سامانه را، صحیح وارد کند و کلیه
                مسئولیت‌های عدم صحت اطلاعات به عهده خود کاربر استفاده‌کننده می‌باشد.
              </Typography>
              <Typography textAlign="justify">
                2- کاربر استفاده‌کننده از این سامانه متعهد گردید از درج هرگونه محتوای خلاف قوانین جمهوری اسلامی ایران در
                سامانه خودداری‌کند و در صورت عدم رعایت این بند، کلیه مسئولیت‌های نقض قوانین بر عهده خود کاربر
                استفاده‌کننده است و همچنین متعهد گردید در صورتی که به علت نقض این بند، خساراتی به سامانه یا هر شخص حقیقی
                یا حقوقی دیگر وارد شود، کلیه زیان‌ها و خسارات وارده را به هر نحو و میزان که دست‌اندرکاران این سامانه
                تعیین کنند جبران کند.
              </Typography>
              <Typography textAlign="justify">
                3- کاربر استفاده‌کننده از این سامانه به حفظ صحیح کلیه اطلاعات کاربری و رمزهای خود در این سامانه متعهد
                گردید و همچنین متعهد گردید کلیه مسئولیت‌های عدم حفظ صحیح این اطلاعات به عهده خود کاربراستفاده‌کننده است.
              </Typography>
              <Typography textAlign="justify">
                4- کاربر استفاده‌کننده از این سامانه متعهد گردید در تمامی تراکنش‌ها و عملیات‌های خود در بستر این سامانه،
                دقت لازم را معمول نماید و مسئولیت کلیه عملیات و تراکنش، در بستر این سامانه بر عهده خود کاربر
                استفاده‌کننده سامانه است.
              </Typography>
              <Typography textAlign="justify">
                5- در صورتی که هر یک از کاربران استفاده‌کننده از این سامانه مطلع از افشاء اطلاعات سایر کاربران
                استفاده‌کننده از این سامانه در هر زمان و به هر شکل شد، باید فوراً حداکثر ظرف 24 ساعت این موضوع را به
                اطلاع طرفی که اطلاعاتش فاش‌شده و همچنین مدیران و دست اندرکاران این سامانه برساند.
              </Typography>
              <Typography textAlign="justify">
                6- کاربر استفاده‎کننده از این سامانه متعهد گردید که کلیه خدمات موجود در این سامانه را که شامل و نه محدود
                به خرید، فروش و تولید است را در بستر قوانین جمهوری اسلامی ایران انجام دهد و در صورت نقض این بند توسط
                کاربر استفاده‌کننده، کلیه عواقب و مسئولیت‌های قانونی بر عهده خود کاربر استفاده‌کننده است.
              </Typography>
              <Typography textAlign="justify">
                7- کاربر استفاده‌کننده از این سامانه متعهد گردید در صورت خروج دائمی از این سامانه به هردلیل و انحلال و
                خروجش از قرارداد با عضو دیگر این سامانه یا سایر اشخاص وابسته به این سامانه که شامل و نه محدود به
                (تامین‌کننده، تولیدکننده، فروشنده) است، کلیه اسرار تجاری را به مدت 30 سال حفظ کند.
              </Typography>
              <Typography textAlign="justify">
                8- کاربر استفاده کننده از این سامانه متعهد گردید با عنایت به نوآوری تکنولوژی این سامانه، حق انجام فعالیت
                مشابه و رقابت به هر نحو با این سامانه را نخواهد داشت.
              </Typography>
              <Typography textAlign="justify">
                9- کلیه حقوق مادی و معنوی این سامانه متعلق به" شرکت فناوری اطلاعات فراهوش کام" است و حق امتياز اين
                سامانه صرفا در انحصار اين شرکت ‌است. کاربر استفاده‌کننده از این سامانه بر اساس ماده 10 قانون مدنی و
                قانون تجارت الکترونیک مصوب 1382 و قانون مسئولیت مدنی مصوب 1339، قانون حمایت از حقوق پدیدآورندگان
                نرم‌افزارهای رایانه ای مصوب 1379 متعهد گردید کلیه اسناد و مدارک خود و سایر کاربران استفاده‌کنندگان از
                این سامانه را و همچنین کلیه اطلاعات نرم‌افزار و سخت‌افزار و داده‌های فناوری و نوآوری این سامانه را حفظ
                کند و در صورت احراز نقض و افشاء اطلاعات در هر درجه و به هر شکل و عنوان که مدیران سامانه تشخیص دهند ،
                ملزم به جبران کلیه خسارات مادی و معنوی کلیه طرفین زیان دیده به هر میزان و کیفیتی که طرف زیان‌دیده و
                دست‌اندرکاران این سامانه مشخص نماید است.
              </Typography>
            </Stack>
          </DialogContent>
          <Stack textAlign="right" pt={6} px={4}>
            <form onSubmit={formik.handleSubmit}>
              <Stack>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="termsAndConditions"
                      checked={formik.values.termsAndConditions}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body1" textAlign="justify">
                      اینجانب تعهدات فوق را با دقت و فهم دقیق مطالعه نمودم و با علم و آگاهی ملزم و متعهد به رعایت کلیه
                      بندهای تعهدنامه فوق شدم و در صورت نقض هر یک از بندهای فوق، عواقب نقض آن را پذیرا هستم و متعهد به
                      جبران کلیه خسارات اعم از مادی و معنوی که از نقض این تعهدنامه و سایر قوانین و مقررات، متوجه این
                      سامانه و سایر اشخاص وابسته به این سامانه شود به هر میزان و کیفتی که مدیران و دست اندرکاران این
                      سامانه تعیین کنند برمی‌آیم.
                    </Typography>
                  }
                />
                {formik.touched.termsAndConditions && formik.errors.termsAndConditions ? (
                  <FormHelperText>{formik.errors.termsAndConditions}</FormHelperText>
                ) : null}
              </Stack>
              <Stack alignItems="center" justifyContent="center" py={2}>
                <BaseBTN
                  sx={{ width: "170px" }}
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={!formik.dirty}
                  onClick={() => {
                    onCloseRegister();
                    handleOpenRealLegal();
                    handleOpenRegister();
                  }}
                >
                  ادامه
                </BaseBTN>
              </Stack>
            </form>
          </Stack>
          <SelectRealLegalDialog onCloseRealLegal={handleCloseRealLegal} openRealLegal={openRealLegal} />
        </Stack>
      ) : (
        <Stack>
          <Stack textAlign="right">
            <Typography variant="subtitle2" color="text.primary" textAlign="left" pt={2} px={4}>
              سامانه زنجیره ارزش آبزیان با هدف افزایش بهره‌وری، توسعه و هوشمندسازی زنجیره ارزش آبزیان طراحی و راه‌اندازی
              گردیده‌است، لذا به همین منظور کلیه کاربران استفاده‌کننده از این سامانه جهت احترام و حفظ کلیه حقوق مادی و
              معنوی دست‌اندرکاران سامانه و سایر کاربران استفاده‌کننده و با هدف ارائه بهتر خدمات متعهد به اجرا تمامی مواد
              مندرج در این تعهدنامه گردیدند.
            </Typography>
          </Stack>
          <Stack pt={2}> </Stack>
          <DialogContent>
            <Stack spacing={2} p={2} bgcolor="grey.gs" sx={{ borderRadius: 2 }} mt={2}>
              <Typography variant="subtitle1" color="primary.main" textAlign="left">
                قوانین و مقررات
              </Typography>
              <Typography textAlign="justify">
                استفاده‌کننده از این سامانه به موجب این تعهدنامه متعهد گردید در حفظ کلیه اطلاعات و اسناد خود و سایر
                استفاده‌کنندگان سامانه کوشا باشد و از هرگونه افشای غیرمجاز و کنترل‌نشده اطلاعات این سامانه و همچنین
                اطلاعات سایر کاربران استفاده‌کننده این سامانه در حین و پس از استفاده از این سامانه ممانعت نماید و همچنین
                کلیه اطلاعات، اسناد و مدارکی که به هر نحو فی مابین طرفین مخابره می‌شود باید در دایره محرمانگی اطلاعات
                قرارگیرد و طرف مقابل متعهد و موظف به حفظ آن می‌باشد که این اطلاعات شامل و نه محدود به (کلیه مدارک
                واحدهای فروش، کلیه مدارک تولیدکنندگان و تامین‌کنندگان ، قیمت‌های خرید و فروش فی مابین طرفین)ست.
              </Typography>
              <Typography textAlign="justify">
                1- کاربر استفاده‌کننده از این سامانه متعهد گردید کلیه اطلاعات خود در سامانه را، صحیح وارد کند و کلیه
                مسئولیت‌های عدم صحت اطلاعات به عهده خود کاربر استفاده‌کننده می‌باشد.
              </Typography>
              <Typography textAlign="justify">
                2- کاربر استفاده‌کننده از این سامانه متعهد گردید از درج هرگونه محتوای خلاف قوانین جمهوری اسلامی ایران در
                سامانه خودداری‌کند و در صورت عدم رعایت این بند، کلیه مسئولیت‌های نقض قوانین بر عهده خود کاربر
                استفاده‌کننده است و همچنین متعهد گردید در صورتی که به علت نقض این بند، خساراتی به سامانه یا هر شخص حقیقی
                یا حقوقی دیگر وارد شود، کلیه زیان‌ها و خسارات وارده را به هر نحو و میزان که دست‌اندرکاران این سامانه
                تعیین کنند جبران کند.
              </Typography>
              <Typography textAlign="justify">
                3- کاربر استفاده‌کننده از این سامانه به حفظ صحیح کلیه اطلاعات کاربری و رمزهای خود در این سامانه متعهد
                گردید و همچنین متعهد گردید کلیه مسئولیت‌های عدم حفظ صحیح این اطلاعات به عهده خود کاربراستفاده‌کننده است.
              </Typography>
              <Typography textAlign="justify">
                4- کاربر استفاده‌کننده از این سامانه متعهد گردید در تمامی تراکنش‌ها و عملیات‌های خود در بستر این سامانه،
                دقت لازم را معمول نماید و مسئولیت کلیه عملیات و تراکنش، در بستر این سامانه بر عهده خود کاربر
                استفاده‌کننده سامانه است.
              </Typography>
              <Typography textAlign="justify">
                5- در صورتی که هر یک از کاربران استفاده‌کننده از این سامانه مطلع از افشاء اطلاعات سایر کاربران
                استفاده‌کننده از این سامانه در هر زمان و به هر شکل شد، باید فوراً حداکثر ظرف 24 ساعت این موضوع را به
                اطلاع طرفی که اطلاعاتش فاش‌شده و همچنین مدیران و دست اندرکاران این سامانه برساند.
              </Typography>
              <Typography textAlign="justify">
                6- کاربر استفاده‎کننده از این سامانه متعهد گردید که کلیه خدمات موجود در این سامانه را که شامل و نه محدود
                به خرید، فروش و تولید است را در بستر قوانین جمهوری اسلامی ایران انجام دهد و در صورت نقض این بند توسط
                کاربر استفاده‌کننده، کلیه عواقب و مسئولیت‌های قانونی بر عهده خود کاربر استفاده‌کننده است.
              </Typography>
              <Typography textAlign="justify">
                7- کاربر استفاده‌کننده از این سامانه متعهد گردید در صورت خروج دائمی از این سامانه به هردلیل و انحلال و
                خروجش از قرارداد با عضو دیگر این سامانه یا سایر اشخاص وابسته به این سامانه که شامل و نه محدود به
                (تامین‌کننده، تولیدکننده، فروشنده) است، کلیه اسرار تجاری را به مدت 30 سال حفظ کند.
              </Typography>
              <Typography textAlign="justify">
                8- کاربر استفاده کننده از این سامانه متعهد گردید با عنایت به نوآوری تکنولوژی این سامانه، حق انجام فعالیت
                مشابه و رقابت به هر نحو با این سامانه را نخواهد داشت.
              </Typography>
              <Typography textAlign="justify">
                9- کلیه حقوق مادی و معنوی این سامانه متعلق به" شرکت فناوری اطلاعات فراهوش کام" است و حق امتياز اين
                سامانه صرفا در انحصار اين شرکت ‌است. کاربر استفاده‌کننده از این سامانه بر اساس ماده 10 قانون مدنی و
                قانون تجارت الکترونیک مصوب 1382 و قانون مسئولیت مدنی مصوب 1339، قانون حمایت از حقوق پدیدآورندگان
                نرم‌افزارهای رایانه ای مصوب 1379 متعهد گردید کلیه اسناد و مدارک خود و سایر کاربران استفاده‌کنندگان از
                این سامانه را و همچنین کلیه اطلاعات نرم‌افزار و سخت‌افزار و داده‌های فناوری و نوآوری این سامانه را حفظ
                کند و در صورت احراز نقض و افشاء اطلاعات در هر درجه و به هر شکل و عنوان که مدیران سامانه تشخیص دهند ،
                ملزم به جبران کلیه خسارات مادی و معنوی کلیه طرفین زیان دیده به هر میزان و کیفیتی که طرف زیان‌دیده و
                دست‌اندرکاران این سامانه مشخص نماید است.
              </Typography>
            </Stack>
          </DialogContent>
          <Stack textAlign="right" pt={6} px={4}>
            <form onSubmit={formik.handleSubmit}>
              <Stack>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="termsAndConditions"
                      checked={formik.values.termsAndConditions}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body1" textAlign="justify">
                      اینجانب تعهدات فوق را با دقت و فهم دقیق مطالعه نمودم و با علم و آگاهی ملزم و متعهد به رعایت کلیه
                      بندهای تعهدنامه فوق شدم و در صورت نقض هر یک از بندهای فوق، عواقب نقض آن را پذیرا هستم و متعهد به
                      جبران کلیه خسارات اعم از مادی و معنوی که از نقض این تعهدنامه و سایر قوانین و مقررات، متوجه این
                      سامانه و سایر اشخاص وابسته به این سامانه شود به هر میزان و کیفتی که مدیران و دست اندرکاران این
                      سامانه تعیین کنند برمی‌آیم.
                    </Typography>
                  }
                />
                {formik.touched.termsAndConditions && formik.errors.termsAndConditions ? (
                  <FormHelperText>{formik.errors.termsAndConditions}</FormHelperText>
                ) : null}
              </Stack>
              <Stack alignItems="center" justifyContent="center" py={2}>
                <BaseBTN
                  sx={{ width: "170px" }}
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={!formik.dirty}
                  onClick={() => {
                    onCloseRegister();
                    handleOpenRegister();
                  }}
                >
                  ادامه
                </BaseBTN>
              </Stack>
            </form>
          </Stack>
          <GuideUsingSmartServicePortalDialog openRegister={open} onCloseRegister={handleCloseRegister} />
        </Stack>
      )}
    </Dialog>
  );
};

export default ConfirmationDialog;
